<template>
    <div class="search-tabs">
        <div class="tabs-button">
            <div class="tab-btn hotel-btn" :class="hotel" @click="clickTab('hotel')">
                <i class="iconfont icon-hotel1"></i>
                {{$t('hotel')}}
            </div>
            <div class="tab-btn flight-btn" :class="flight" @click="clickTab('flight')">
                <i class="iconfont icon-feiji"></i>
                {{$t('flight')}}
            </div>
        </div>

        <div class="search-panel">
            <fligh-search v-show="type === 'flight'"></fligh-search>
            <search-bar v-show="type === 'hotel'" @on-search="search" @hot_hotle="hotsList"></search-bar>
        </div>
    </div>
</template>

<script>
import SearchBar from "../home/components/Searchbar.vue";
import FlighSearch from "./components/FlightSearch";
export default {
    name: "iSearch",
    components: {
        SearchBar,
        FlighSearch
    },
    data() {
        return {
            type: "hotel",
            flight: "",
            hotel: "tab-btn-active",
            hotsData: []
        };
    },
    methods: {
        clickTab(type) {
            if (this.type !== type) {
                this[type] = "tab-btn-active";
                this[type === "flight" ? "hotel" : "flight"] = "";
                this.type = type;
            }
        },
        hotsList(index) {
            this.hotsData = index;
        },
        search(data) {
            // 保存搜索记录
            this.saveSearchRecord(data.city);
        },
        saveSearchRecord(cityName) {
            if (!cityName) return false;
            let keywords = this.$local.get("keywords") || [];
            if (keywords.length === 0) {
                keywords.push({
                    name: cityName
                });
            } else if (keywords.length > 0 && keywords.length <= 10) {
                // 如何列表已经存在则不要存
                let s = false;
                for (let keyword of keywords) {
                    if (keyword.name === cityName) {
                        s = true;
                        break;
                    }
                }
                if (!s) {
                    keywords.push({
                        name: cityName
                    });
                }
            } else if (keywords.length > 10) {
                keywords.push({
                    name: cityName
                });
                keywords.shift();
            }
            this.$local.set("keywords", keywords);
        }
    }
};
</script>

<style lang="scss" scoped>
.search-tabs {
    .tabs-button {
        display: flex;
        align-items: flex-end;
        font-size: 16px;
        color: #fff;

        .tab-btn {
            padding: 12px 25px;
            background-color: rgba(2, 144, 158, 0.9);
            cursor: pointer;

            i {
                margin-right: 12px;
            }
        }

        .hotel-btn {
            border-radius: 5px 0 0 0;
        }

        .flight-btn {
            border-radius: 0 5px 0 0;
        }

        .tab-btn-active {
            border-radius: 5px 5px 0 0;
            padding: 17px 25px 12px 25px;
            background-color: #fff;
            color: #00a9ba;
        }
    }

    .search-panel {
        box-sizing: border-box;
        padding: 0 30px 40px 30px;
        background-color: #fff;
        border-radius: 0 5px 5px 5px;
        box-shadow: 2px 5px 10px rgba(0, 0, 0, 0.2);
    }
}
.search-bar {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/Public/Search.vue